module.exports = __webpack_public_path__ + "static/media/image-14.95a33eb3.PNG";